export enum IntegrationType {
  WORDPRESS = "WORDPRESS",
  WIX = "WIX",
  SHOPIFY = "SHOPIFY",
  CUSTOM = "CUSTOM",
}
